import * as Yup from "yup";

export const UnitCategorySchema = Yup.object().shape({
  label: Yup.string().required("Label is required"),
  mainDescription: Yup.string().required("Main description is required"),
});
